import { Node, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import ReactPlayer from 'react-player';
import { useState } from 'react';

const VideoBlockView = (props) => {
    const { node } = props;
    const isFullDisplay = node.attrs.layout || "default";
    const isLoopActive = node.attrs.loop || false;
    const [isVideoReady, setIsVideoReady] = useState(false);

    const handleVideoReady = () => {
        setIsVideoReady(true);
    };

    return (
        <NodeViewWrapper data-type='video'>
            <div className='video-wrapper' >
                {node.attrs.videoUrl ? (
                    <div className={`image-preview image-width-${isFullDisplay}`}>
                        { !isVideoReady &&
                            <div contentEditable={false} className="skeleton-video-wrapper"><div className="skeleton-video"></div></div>
                        }
                        <div contentEditable={false} className={(isVideoReady) ? 'player-wrapper player-ready' : 'player-wrapper'}>
                            <ReactPlayer
                                className='react-player'
                                url={node.attrs.videoUrl}
                                width='100%'
                                height='100%'
                                light={node.attrs.thumbnailurl}
                                controls
                                onReady={handleVideoReady}
                                loop={isLoopActive}
                            />
                        </div>
                        <div className='video-title' contentEditable={false}>
                            <p className='video-caption' contentEditable={true}>{node.attrs.caption}</p>
                        </div>
                    </div>
                ) : (
                    <p>No video available</p>
                )}
            </div>
        </NodeViewWrapper>
    );
};

export const VideoBlock = Node.create({
    name: 'VideoBlock',

    group: 'block',
    defining: true,
    isolating: true,

    addAttributes() {
        return {
            videoUrl: {
                default: '',
            },
            caption: {
                default: '',
            },
            width: {
                default: 'auto', // Default width value
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
                getAttrs: (dom) => {
                    const video = dom.querySelector('video');
                    return {
                        videoUrl: video ? video.getAttribute('src') : '',
                        caption: dom.getAttribute('data-caption') || '',
                        
                        width: dom.style.width || 'auto',
                    };
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        const { videoUrl, caption, width } = HTMLAttributes;
        const style = `width: ${width}; height: auto;`;
    
        return [
            'div',
            { 
                'data-type': this.name, 
                'data-caption': caption, 
                class: 'video-block',
                style: `width: ${width}` 
            },
            videoUrl
                ? [
                    'div',
                    { class: `video-preview` }, // Similar to ImageBlock class
                    [
                        'video',
                        { 
                            src: videoUrl, 
                            controls: true,
                            style 
                        }
                    ],
                    caption
                        ? ['p', { class: 'video-caption' }, caption]
                        : ''
                ]
                : ['p', {}, 'No video available'],
        ];
    },

    addCommands() {
        return {
            setVideoBlock:
                (options) =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: {
                                videoUrl: options?.videoUrl || '',
                                caption: options?.caption || '',
                                loop: options?.loop || false,
                            },
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(VideoBlockView);
    },
});


